import script from "./PettyCashView.vue?vue&type=script&setup=true&lang=js"
export * from "./PettyCashView.vue?vue&type=script&setup=true&lang=js"

import "./PettyCashView.vue?vue&type=style&index=0&id=6f210d91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f210d91"]])

export default __exports__